import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_LINK_DISTRIBUTIONS = createRequestTypes('LINK_DISTRIBUTION_GET_LINK_DISTRIBUTIONS');
export const getLinkDistributions = {
  request: payload => action(GET_LINK_DISTRIBUTIONS[REQUEST], { payload }),
  success: payload => action(GET_LINK_DISTRIBUTIONS[SUCCESS], { payload }),
  failure: error => action(GET_LINK_DISTRIBUTIONS[FAILURE], { error }),
};

export const CREATE_LINK_DISTRIBUTION = createRequestTypes('LINK_DISTRIBUTION_CREATE_LINK_DISTRIBUTION');
export const createLinkDistribution = {
  request: payload => action(CREATE_LINK_DISTRIBUTION[REQUEST], { payload }),
  success: payload => action(CREATE_LINK_DISTRIBUTION[SUCCESS], { payload }),
  failure: error => action(CREATE_LINK_DISTRIBUTION[FAILURE], { error }),
};

export const UPDATE_LINK_DISTRIBUTION = createRequestTypes('LINK_DISTRIBUTION_UPDATE_LINK_DISTRIBUTION');
export const updateLinkDistribution = {
  request: payload => action(UPDATE_LINK_DISTRIBUTION[REQUEST], { payload }),
  success: payload => action(UPDATE_LINK_DISTRIBUTION[SUCCESS], { payload }),
  failure: error => action(UPDATE_LINK_DISTRIBUTION[FAILURE], { error }),
};

export const DELETE_LINK_DISTRIBUTION = createRequestTypes('LINK_DISTRIBUTION_DELETE_LINK_DISTRIBUTION');
export const deleteLinkDistribution = {
  request: payload => action(DELETE_LINK_DISTRIBUTION[REQUEST], { payload }),
  success: payload => action(DELETE_LINK_DISTRIBUTION[SUCCESS], { payload }),
  failure: error => action(DELETE_LINK_DISTRIBUTION[FAILURE], { error }),
};

export const GET_TAGS = createRequestTypes('LINK_DISTRIBUTION_GET_TAGS');
export const getTags = {
  request: payload => action(GET_TAGS[REQUEST], { payload }),
  success: payload => action(GET_TAGS[SUCCESS], { payload }),
  failure: error => action(GET_TAGS[FAILURE], { error }),
};

export const SET_FILTERS = 'LINK_DISTRIBUTION_SET_FILTERS';
export const setFilters = payload => ({ type: SET_FILTERS, payload });
